import { HttpContextToken } from "@angular/common/http";

export const SkipByAuthTokenInterceptor = new HttpContextToken(() => true);
